export default __webpack_public_path__ + "static/media/clients-logo.226312a2.png";